/**
 * Locale-aware date/time formatting utilities using native Intl API.
 */
export function formatDate(isoString, locale = 'en-US') {
    try {
        const date = new Date(isoString);
        return new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        }).format(date);
    }
    catch {
        return isoString;
    }
}
export function formatTime(isoString, locale = 'en-US') {
    try {
        const date = new Date(isoString);
        return new Intl.DateTimeFormat(locale, {
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    }
    catch {
        return isoString;
    }
}
export function formatDateTime(isoString, locale = 'en-US') {
    try {
        const date = new Date(isoString);
        return new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    }
    catch {
        return isoString;
    }
}
